import React from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { googleAuthApiRef } from '@backstage/core-plugin-api';

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => (
          <SignInPage
            {...props}
            auto
            provider={{
              id: 'google-auth-provider',
              title: 'MarketCast Google Workspace',
              message: 'Sign in with your @marketcast.com Google account',
              apiRef: googleAuthApiRef,
            }}
          />
        ),
      },
    }),
  ],
});
